export default "__VITE_ASSET__CzyR7WYZ__"